import React, { useState, useEffect } from 'react';
import Header from '../page-layout/header/Header';
import Footer from '../page-layout/footer/Footer';
import NavMenu from '../navigation/Navmenu';
import "../dashboard/Dashboard.css";
import { useNavigate } from 'react-router-dom';
import { Row, Col, Card, Container, Button, Form, Modal } from "react-bootstrap";
import "react-data-table-component-extensions/dist/index.css";
import { Decrypt, Encrypt } from '../../utils/Helper';
import { GetDashboardCount } from '../../utils/axios/DashboardAPI';
import { GetUserById } from '../../utils/axios/UserApi'; 
import { getRoles } from '../../utils/swtAlert';
import { GetMyChallenges } from '../../utils/axios/MyChallengesAPI';
import { GrokLoading } from '../page-layout/loading/Loading';
import configData from '../../config.json';

function Dashboard() {
  const navigate = useNavigate();
  const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
  
  const [userDetails, setUserDetails] = useState('');
  const [challengeId, setChallengeId ] = useState('');
  const [showOptions, setShowOptions] = useState(false);
  const [showChallengesList, setShowChallengesList] = useState(false);
  const [challengesListFilter, setChallengesListFilter] = useState([]);
  const [challengesList, setChallengesList ] = useState([]);
  const [show, setShow] = useState(false);
  const [isProjectSubmission, setIsProjectSubmission] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleClose = () => {
    setShow(false);
    setChallengeId('');
  }
  const handleShow = () => {
    getMyChallenges();
    setShow(true);
  }

  const handleOptionClick = (name) => {
    setChallengeId(name);
  }
  
  const getMyChallenges = async () =>{
    let getMyChallengesPayload = {
        StudentId: userInfo.StudentId
    }
    setLoading(true);
    var myChallengesResponse = await GetMyChallenges(getMyChallengesPayload);
    setLoading(false);
    setChallengesList(myChallengesResponse.data);
    setChallengesListFilter(myChallengesResponse.data);
    if (myChallengesResponse.data.length > 0) {
      setShowChallengesList(true);
    }
  }
 
  const getUser = async () => {
    var userResponse = await GetUserById(userInfo._id);
    
    sessionStorage.setItem("userDetails", Encrypt(userResponse.data));
    setUserDetails(Decrypt(sessionStorage.getItem('userDetails')));

  }
  const [role, setRole] = useState('');
  const [dashboardData, setDashboardData] = useState([]);
  let curDate = new Date().getHours();
  let greetings = "";
  const cssStyle = {};

    if(curDate >= 1 && curDate <= 11.59){
      greetings = "Good Morning!";
      cssStyle.color = "#fa9d11";
    }
    else if(curDate >= 12 && curDate <= 17.59){
      greetings = "Good Afternoon!";
      cssStyle.color = "#1876ff";
    }else{
        greetings = "Good Evening!";
        cssStyle.color = "#ff0080";
    }

  const listOfRegisterCompany = () => {
    navigate('/industrypartner');
  }

  const listOfParticipants = () => {
    navigate('/participants');
  }

  const listOfBusinessChallenges = () => {
    navigate('/industryusecase');
  }

  const listOfRegisteredColleges = () => {
    navigate('/associatecollege');
  }
  const grovatorLab = () => {
    navigate('/grovatorlab');
  }

  const listOfRegisteredChallenges = () => {
    navigate('/myindustryusecase');
  }

  const linkToGrovatorLab = () => { 
    window.open('https://lms.grovator.com/', "_blank");
  }

  const linkToLMS = () => {
    handleShow();
    setIsProjectSubmission(false);
  }

  const ProjectSubmission = () => {
    handleShow();
    setIsProjectSubmission(true);
  }

  const submitProject = () => {
    let challenge = challengesList.find(item => item.ChallengeId.name === challengeId);
    if (challenge.Solution === null ){
      navigate('/myindustryusecasedetails',  {state: {myChallengeid: challenge._id, challengeid: challenge.ChallengeId.id}});
    }
    else{
      navigate('/myindustryusecase', {state: {challengeid: challenge._id}});
    }
  }

  const linkToLMSMobileApp = () => {
    window.open(`${configData.GROK_ENDPOINT}/mobile/mobile-app/?student=${userDetails.StudentId}&studentName=${(userDetails.Name)}`, "_self")
  }

  const createNewApp = () => {
    let challenge = challengesList.find(item => item.ChallengeId.name === challengeId);

    // window.open('http://localhost:4200/auth/auto-login/', "_self");
    if (!challenge.ApplicationIdentifier) {
      window.open(`${configData.GROK_ENDPOINT}/auth/auto-login/${challenge.ChallengeId.id}/${(userDetails.Name)}/${userDetails.StudentId}?token=${window.btoa(Decrypt(sessionStorage.getItem('token')))}`, "_self");
    }
    else {
      window.open(`${configData.GROK_ENDPOINT}/auth/auto-login/${challenge.ChallengeId.id}/${(userDetails.Name)}/${userDetails.StudentId}?token=${window.btoa(Decrypt(sessionStorage.getItem('token')))}&appIdentifier=${challenge.ApplicationIdentifier}`, "_self");
    }
  }

  const counter = () => {
  let valueDisplays = document.querySelectorAll(".mart-num");
  let interval = 2000;

  valueDisplays.forEach((valueDisplay) => {
      let startValue = 0;
      let endValue = parseInt(valueDisplay.getAttribute("data-val"));
      
      if(endValue != 0){
        let duration = Math.floor( interval / endValue);
        let counter = setInterval(function () {
            startValue += 1;
            valueDisplay.textContent = startValue;
            if(startValue === endValue) {
                clearInterval(counter);
            }
        }, duration);
      }
  });}

  const getDashboardData = async () => {
    setLoading(true);
    const response = await GetDashboardCount();
    setLoading(false);
    setDashboardData(response);
    setTimeout(() => counter(), 10)
  }
  useEffect(() => {
    setTimeout(() => {
      document.cookie = 'user'
    })
    setChallengesListFilter(challengeId?.length > 0 ? challengesList.filter((item) => item.ChallengeId.name.toLowerCase().includes(challengeId.toLowerCase())) : challengesList);
  }
  , [challengeId]);

  useEffect(() => {
    const close = localStorage.getItem('close');
    localStorage.setItem('theme', close)
    const role = getRoles(userInfo);
    setRole(role);
    getDashboardData();
    getUser();
    document.querySelectorAll(".navbar-nav .nav-item a")[0].classList.add("active");
  }, []);

  return (
    <div className="page">
    {loading ? <GrokLoading /> : ""}
      <NavMenu />
      <Header />

      <div className="page-wrapper">
        <Container fluid>
          {/* Start Page Header */}
          <div className="page-header d-print-none pb-2 pt-1">
            <Row className="g-2 align-items-center">
              <Col style={{ display: 'flex', alignItems: 'center' }}>
                <Button className='nave-icon' variant='ouline' size='sm' title='Dashboard'>
                  <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path d="M261.56 101.28a8 8 0 00-11.06 0L66.4 277.15a8 8 0 00-2.47 5.79L63.9 448a32 32 0 0032 32H192a16 16 0 0016-16V328a8 8 0 018-8h80a8 8 0 018 8v136a16 16 0 0016 16h96.06a32 32 0 0032-32V282.94a8 8 0 00-2.47-5.79z"></path><path d="M490.91 244.15l-74.8-71.56V64a16 16 0 00-16-16h-48a16 16 0 00-16 16v32l-57.92-55.38C272.77 35.14 264.71 32 256 32c-8.68 0-16.72 3.14-22.14 8.63l-212.7 203.5c-6.22 6-7 15.87-1.34 22.37A16 16 0 0043 267.56L250.5 69.28a8 8 0 0111.06 0l207.52 198.28a16 16 0 0022.59-.44c6.14-6.36 5.63-16.86-.76-22.97z"></path></svg></span>
                </Button>
                <h2 className="page-title"> Home</h2>
              </Col>
            </Row>
          </div>
          {/* End Page Header */}

          {/* Start Status */}
          <div className="page-body">
            <Row>
              { role==("Grok Admin") && <h5>Welcome  <b>{userDetails.Name}, </b><em> <span style={cssStyle}> {greetings}</span></em></h5>}
              { role==("College") && <h5>Welcome  <b>{userDetails.Name},  </b><em> <span style={cssStyle}> {greetings}</span></em></h5>}
              { role=="Student" && <h5>Welcome  <b>{userDetails.Name},  </b><em> <span style={cssStyle}> {greetings}</span></em></h5>}
              { role=="Company" && <h5>Welcome  <b>{userDetails.Name},  </b><em> <span style={cssStyle}> {greetings}</span></em></h5>}
            </Row><br/>

           {/* logical-rows Start */}

           <Row className='d-flex flex-wrap justify-content-center'>

            {/* logical card A start */}
            <Col sm={6} lg={6} xl={4} className="mb-3 mb-lg-5">
                <Card className="card-hover-shadow h-100 card1_border">
                  <Card.Body className='mart-card'>
                    <Card.Title className="subheader text-center">
                      <b>Grok Learning Industry Partners</b>
                    </Card.Title>
                    <div className="stbox d-flex flex-wrap justify-content-center align-items-center margin-logo-text-card">
                      <div className="stlogo bg-ltgreen">
                        <img src={require("../../images/branches.png")} className="img-fluid" width={40} alt="hospital-card" />
                      </div>
                      <div className="pecntagtext">
                        {/* <h5 className="h5 mb-1 dashboard_card_label"> {dashboardData?.TotalCompanies}</h5> */}
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            {/* logical card A end */}

            {/* logical card X start */}
            { role=='Company' &&
              <Col sm={6} lg={6} xl={4} className="mb-3 mb-lg-5">
              <Card className="card-hover-shadow h-100 card4_border">
                <Card.Body className='mart-card'>
                  <Card.Title className="subheader text-center">
                    <b>Universities & Colleges</b>
                  </Card.Title>
                  <div className="stbox d-flex flex-wrap justify-content-center align-items-center margin-top-sm margin-bottom-sm">
                    <div className="stlogo bg-ltred">
                      <img src={require("../../images/school.png")} className="img-fluid" width={40} alt="family-card" />
                    </div>
                    <div className="pecntagtext">
                      {/* <h5 className="h5 mb-1 dashboard_card_label"> {dashboardData?.TotalCollege}</h5> */}
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            }
            {/* logical card X end */}

            {/* logical card B start */}
            <Col sm={6} lg={6} xl={4} className="mb-3 mb-lg-5">
                <Card className="card-hover-shadow h-100 card3_border">
                  <Card.Body className='mart-card'>
                    <Card.Title className="subheader text-center">
                      <b>Industry Problem Statements</b>
                    </Card.Title>
                    <div className="stbox d-flex flex-wrap justify-content-center align-items-center margin-logo-text-card">
                      <div className="stlogo bg-ltorange">
                        <img src={require("../../images/challenge.png")} className="img-fluid" width={40} alt="doctor-card" />
                      </div>
                      <div className="pecntagtext">
                        {/* <h5 className="h5 mb-1 dashboard_card_label"> {dashboardData?.PublishChallenges}</h5> */}
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            {/* logical card B end */}

            {/* logical card C start */}
            { (role==('Grok Admin')||(role==('Student'))) &&
              <Col sm={6} lg={6} xl={4} className="mb-3 mb-lg-5">
                  <Card className="card-hover-shadow h-100 card4_border">
                    <Card.Body className='mart-card'>
                      <Card.Title className="subheader text-center">
                        <b>Universities & Colleges</b>
                      </Card.Title>
                      <div className="stbox d-flex flex-wrap justify-content-center align-items-center margin-top-sm margin-bottom-sm">
                        <div className="stlogo bg-ltred">
                          <img src={require("../../images/school.png")} className="img-fluid" width={40} alt="family-card" />
                        </div>
                        <div className="pecntagtext">
                          {/* <h5 className="h5 mb-1 dashboard_card_label"> {dashboardData?.TotalCollege}</h5> */}
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
              </Col>
            }
            {/* logical card C end */}

            {/* logical card D start */}
            {
              (role==('College')) &&
              <Col sm={6} lg={6} xl={4} className="mb-3 mb-lg-5">
                <Card className="card-hover-shadow h-100 card2_border">
                  <Card.Body className='mart-card'>
                    <Card.Title className="subheader text-center">
                      <b>Participants</b>
                    </Card.Title>
                    <div className="stbox d-flex justify-content-center flex-wrap align-items-center margin-logo-text-card">
                      <div className="stlogo bg-ltblue">
                        <img src={require("../../images/customers.png")} className="img-fluid" width={40} alt="patient-card" />
                      </div>
                      <div className="pecntagtext">
                        {/* <h5 className="h5 mb-1 dashboard_card_label"> {dashboardData?.CollegeStudent}</h5> */}
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            }
            {/* logical card D end */}

           </Row>

           {/* logical-rows Ends */}
            
            { (role==('Grok Admin')) && <div className="pt-2">
              <Row>
                <Col sm={6} lg={6} xl={4} className="mb-3 mb-lg-5" onClick={() =>listOfRegisterCompany()}>
                  <Card className="grok-card card-hover-shadow h-100 p-2 d-flex flex-column">
                    <div id="zoomIn" className='flex-1per'>
                      <img className="img-w-h img-fluid" src={require("../../images/listofRegisterCompanies.png")} /> 
                    </div>
                    <Card.Body className="card-body text-center pt-4">
                      <p className='grok-link'>Grok Learning Industry Partners</p>
                    </Card.Body>
                  </Card>
                </Col>
                
                <Col sm={6} lg={6} xl={4} className="mb-3 mb-lg-5"  onClick={() => listOfBusinessChallenges()}>
                  <Card className="grok-card card-hover-shadow h-100 p-2 d-flex flex-column">
                    <div id="zoomIn" className='flex-1per'>
                      <img className="img-w-h img-fluid" src={require("../../images/listofBusinessChallenge.png")} />
                    </div>
                    <Card.Body className="card-body text-center pt-4">
                      <p className='grok-link'>Industry Problem Statements</p>
                    </Card.Body>
                  </Card>
                </Col>

                <Col sm={6} lg={6} xl={4} className="mb-3 mb-lg-5" onClick={() => listOfRegisteredColleges()}>
                  <Card className="grok-card card-hover-shadow h-100 p-2 d-flex flex-column">
                    <div id="zoomIn" className='flex-1per'>
                      <img className="img-w-h img-fluid" src={require("../../images/registerCompany.png")} /> 
                    </div>
                    <Card.Body className="card-body text-center pt-4">
                      <p className='grok-link'>Academic <br/>Universities and Colleges</p>
                    </Card.Body>
                  </Card>
                </Col>

                {/* <Col sm={6} lg={6} xl={3} className="mb-3 mb-lg-5" onClick={() => grovatorLab()}>
                  <Card className="grok-card card-hover-shadow h-100 p-2 d-flex flex-column">
                    <div id="zoomIn" className='flex-1per'>
                      <img className="img-w-h img-fluid" src={require("../../images/studentGrovatorLap.png")} />  
                    </div>
                    <Card.Body className="card-body text-center pt-4">
                      <p className='grok-link'>Participants</p>
                    </Card.Body>
                  </Card>
                </Col> */}
              </Row>
            </div>}
            
            { role=='Student' && <div className="py-3">
              <Row xs={1} sm={2} md={2} lg={5}>
                <Col className="mb-3 mb-lg-5" onClick={() => listOfRegisterCompany()}>
                  <Card className="grok-card card-hover-shadow h-100 p-2 d-flex flex-column">
                    <div id="zoomIn" className='flex-1per'>
                      <img className="img-w-h img-fluid" src={require("../../images/listofRegisterCompanies.png")} /> 
                    </div>
                    <Card.Body className="card-body text-center pt-4">
                      <p className='grok-link'>Grok Learning Industry Partners</p>
                    </Card.Body>
                  </Card>
                </Col> 

                <Col className="mb-3 mb-lg-5" onClick={() => listOfRegisteredChallenges()}>
                  <Card className="grok-card card-hover-shadow h-100 p-2 d-flex flex-column">
                    <div id="zoomIn" className='flex-1per'>
                      <img className="img-w-h img-fluid" src={require("../../images/listofBusinessChallenge.png")} /> 
                    </div>
                    <Card.Body className="card-body text-center pt-4">
                      <p className='grok-link'>Industry Problem Statements</p>
                    </Card.Body>
                  </Card>
                </Col> 

                <Col className="mb-3 mb-lg-5" onClick={() => linkToLMS()}>
                  <Card className="grok-card card-hover-shadow h-100 p-2 d-flex flex-column">
                    <div id="zoomIn" className='flex-1per'>
                      <img className="img-w-h img-fluid" src={require("../../images/LMS_platform.png")} /> 
                    </div>
                    <Card.Body className="card-body text-center pt-4">
                      <p className='grok-link'>Create Your Solution</p>
                    </Card.Body>
                  </Card>
                </Col>

                <Col className="mb-3 mb-lg-5" onClick={() => linkToLMSMobileApp()}>
                  <Card className="grok-card card-hover-shadow h-100 p-2 d-flex flex-column">
                    <div id="zoomIn" className='flex-1per'>
                      <img className="img-w-h img-fluid" src={require("../../images/Mobile_user.png")} /> 
                    </div>
                    <Card.Body className="card-body text-center pt-4 mt-3">
                      <p className='grok-link'>Test Your Solution Using Mobile App</p>
                    </Card.Body>
                  </Card>
                </Col>

                <Col className="mb-3 mb-lg-5" onClick={() => ProjectSubmission()}>
                  <Card className="grok-card card-hover-shadow h-100 p-2 d-flex flex-column">
                    <div id="zoomIn" className='flex-1per'>
                      <img className="img-w-h img-fluid" src={require("../../images/projectSubmit.png")} />  
                    </div>
                    <Card.Body className="card-body text-center pt-4">
                      <p className='grok-link'>Post Your Solution</p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>}
            
            { role=='Company' && <div className="py-3">
              <Row>
                <Col sm={6} lg={6} xl={4} className="mb-3 mb-lg-5" onClick={() => linkToGrovatorLab()}>
                  <Card className="grok-card card-hover-shadow h-100 p-2 d-flex flex-column">
                    <div id="zoomIn" className='flex-1per'>
                      <img className="img-w-h img-fluid" src={require("../../images/LMS_platform.png")} /> 
                    </div>
                    <Card.Body className="card-body text-center pt-4">
                      <p className='grok-link'>GROVATOR &reg; Applied Learning & Skilling Platform</p>
                    </Card.Body>
                  </Card>
                </Col>

                <Col sm={6} lg={6} xl={4} className="mb-3 mb-lg-5"  onClick={() => listOfRegisteredColleges()}>
                  <Card className="grok-card card-hover-shadow h-100 p-2 d-flex flex-column">
                    <div id="zoomIn" className='flex-1per'>
                      <img className="img-w-h img-fluid" src={require("../../images/postBusinessChallenges.png")} /> 
                    </div>
                    <Card.Body className="card-body text-center pt-4">
                      <p className='grok-link'>Academic <br/>Universities and Colleges</p>
                    </Card.Body>
                  </Card>
                </Col>

                <Col sm={6} lg={6} xl={4} className="mb-3 mb-lg-5"  onClick={() => listOfBusinessChallenges()}>
                  <Card className="grok-card card-hover-shadow h-100 p-2 d-flex flex-column">
                    <div id="zoomIn" className='flex-1per'>
                      <img className="img-w-h img-fluid" src={require("../../images/listofBusinessChallenge.png")} /> 
                    </div>
                    <Card.Body className="card-body text-center pt-4">
                      <p className='grok-link'>Industry Problem Statements</p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>}
            { role=='College' && <div className="py-3">
              <Row>
                <Col sm={6} lg={6} xl={4} className="mb-3 mb-lg-5" onClick={() => listOfRegisterCompany()}>
                  <Card className="grok-card card-hover-shadow h-100 p-2 d-flex flex-column">
                    <div id="zoomIn" className='flex-1per'>
                      <img className="img-w-h img-fluid" src={require("../../images/listofRegisterCompanies.png")} /> 
                    </div>
                    <Card.Body className="card-body text-center pt-4">
                      <p className='grok-link'>Grok Learning Industry Partners</p>
                    </Card.Body>
                  </Card>
                </Col> 

                <Col sm={6} lg={6} xl={4} className="mb-3 mb-lg-5" onClick={() => listOfBusinessChallenges()}>
                  <Card className="grok-card card-hover-shadow h-100 p-2 d-flex flex-column">
                    <div id="zoomIn" className='flex-1per'>
                      <img className="img-w-h img-fluid" src={require("../../images/listofBusinessChallenge.png")} /> 
                    </div>
                    <Card.Body className="card-body text-center pt-4">
                      <p className='grok-link'>Industry Problem Statements</p>
                    </Card.Body>
                  </Card>
                </Col> 

                <Col sm={6} lg={6} xl={4} className="mb-3 mb-lg-5" onClick={() => listOfParticipants()}>
                  <Card className="grok-card card-hover-shadow h-100 p-2 d-flex flex-column">
                    <div id="zoomIn" className='flex-1per'>
                      <img className="img-w-h img-fluid" src={require("../../images/studentGrovatorLap.png")} />  
                    </div>
                    <Card.Body className="card-body text-center pt-4">
                      <p className='grok-link'>Participants</p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>}
          </div>
            
          <div>
            <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} className="model-popup" aria-labelledby="contained-modal-title-vcenter" centered>
              {loading ? <GrokLoading /> : ""}
              <Modal.Header closeButton>
                <Modal.Title><b>Create Use Case Solution</b> </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div>
                  <Row className="mb-4 align-items-center">
                    <Col >
                      <Form.Label className="form-label mb-3 fw-bold">Industry Problem Statements List</Form.Label>
                        <div className="auto-complete-org Org_css">
                          <Form.Control type="text" className="change_formControl" value={challengeId} onChange={(e) => setChallengeId(e.target.value)}  onFocus={() => setShowOptions(true)} placeholder="Search..." />
                            <ul className="ul-list">
                              {/* <option value={""}>choose organization... </option> */}
                                {
                                  (challengesListFilter.map((item) => (
                                    <option className="list-options" key={item._id} title={item.ChallengeId?.name } onClick={() => handleOptionClick(item.ChallengeId.name)} value={item.ChallengeId?.id}>{item.ChallengeId.name}</option>
                                  )))
                                }
                            </ul>
                        </div>
                    </Col>
                  </Row>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Row>
                  <Col>
                    <Button variant="secondary" type="button" size="sm" onClick={handleClose}>Cancel</Button>
                  </Col>
                  <Col className="col-md-auto">
                    <Button variant="primary" color="primary" size="sm" disabled={!challengeId} onClick={isProjectSubmission ? submitProject : createNewApp} > {isProjectSubmission ? "Open" :"Create Solution"}</Button>
                  </Col>
                </Row>
              </Modal.Footer>
            </Modal>
          </div>
        </Container>
        <Footer />
      </div>
    </div>
  )
}

export default Dashboard